import { render, staticRenderFns } from "./ObjectivePosTable.vue?vue&type=template&id=37145099"
import script from "./ObjectivePosTable.vue?vue&type=script&lang=js"
export * from "./ObjectivePosTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports